import { render, staticRenderFns } from "./AgentPrivileges.vue?vue&type=template&id=0d4d59f0&scoped=true&"
import script from "./AgentPrivileges.vue?vue&type=script&lang=js&"
export * from "./AgentPrivileges.vue?vue&type=script&lang=js&"
import style0 from "./AgentPrivileges.vue?vue&type=style&index=0&id=0d4d59f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4d59f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VContainer,VDataTable,VIcon,VSelect,VTextField})
